import { App, createApp } from 'vue'
import { createPinia } from 'pinia'
import ProductPage from '@/components/product/ProductPage.vue'

const pinia = createPinia()

function mount({ el, props }: {el:any, props:any}) {
    let app: App<Element> | undefined = createApp(ProductPage, props)
        .use(pinia)
        .component('ProductPage', ProductPage)
        .provide('authAdmin', false)
    app.mount(el)
    
    return () => {
        // destroy app/component
        app?.unmount()
        app = undefined
    }
}

export function mountProductPage() {
    const element:any = document.querySelector('#product_page_target')
    if(element) {
        const id = element?.dataset?.id
        return mount(
            {
                el: document.querySelector('#product_page_target'),
                props: {
                    productId: id || 0
                },
            },
        )
    }
}